import React, { FC, useRef } from 'react';

import Image from 'next/image';
import { useTranslation } from 'next-i18next/pages';

import Logo1 from '@/assets/partner-logos/logo-001.webp';
import Logo2 from '@/assets/partner-logos/logo-002.webp';
import Logo3 from '@/assets/partner-logos/logo-003.webp';
import Logo4 from '@/assets/partner-logos/logo-004.webp';
import Logo5 from '@/assets/partner-logos/logo-005.webp';
import Logo6 from '@/assets/partner-logos/logo-006.webp';
import Logo7 from '@/assets/partner-logos/logo-007.webp';
import Logo8 from '@/assets/partner-logos/logo-008.webp';
import Arrow from '@/assets/question-arrow-down.svg';
import { TranslationNamespace } from '@/i18n';

import styles from './WithUsSection.module.scss';

const logos = [Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8];

export const WithUsSection: FC = () => {
	const t = useTranslation(TranslationNamespace.Marketing).t;
	const partnersRef = useRef<HTMLDivElement>(null);

	const handleLeftArrowClick = () => {
		partnersRef.current?.scrollBy({ left: -180, behavior: 'smooth' });
	};
	const handleRightArrowClick = () => {
		partnersRef.current?.scrollBy({ left: 180, behavior: 'smooth' });
	};

	return (
		<section className={styles.newsSection}>
			<div className={styles.title}>
				{t('about-us-container.already-on-fishplace-already-with-us')}
			</div>
			<div className={styles.description}>
				{t('about-us-container.fishplace-has-already-been-supported')}
				<br />
				{t(
					'about-us-container.by-the-leaders-of-the-russian-fishing-industry-we-are-waiting-for-you',
				)}
			</div>

			<div className={styles.partnersWrapper}>
				<Image
					src={Arrow}
					className={styles.leftArrow}
					width={24}
					height={24}
					onClick={handleLeftArrowClick}
					alt=""
				/>
				<div className={styles.partners} ref={partnersRef}>
					{logos.map((logo, index) => (
						<Image
							key={index}
							width={168}
							height={168}
							src={logo}
							alt={t('about-us-container.partner-logo')}
						/>
					))}
				</div>
				<Image
					src={Arrow}
					className={styles.rightArrow}
					width={24}
					height={24}
					onClick={handleRightArrowClick}
					alt=""
				/>
			</div>
		</section>
	);
};
